import type { AxiosInstance } from "axios";
import type { CreateUserBody } from "@shared/schemas/user-write.schemas";
import type { UserAdminView } from "@shared/schemas/user-views.schemas";

export function createUsersAdminApi(apiClient: AxiosInstance) {
  return {
    async create(body: CreateUserBody): Promise<UserAdminView> {
      const response = await apiClient.post<UserAdminView>(
        "/api/v1/admin/users",
        body,
      );
      return response.data;
    },
  };
}
